import {
  generateGetInfiniteResourceKey,
  generateGetResourceKey,
  generateHttpGet,
} from "../../utils/fetcherUtils";

import { Params, Result } from "./typing";

export const httpGet$ExplorePolicyList = generateHttpGet<Params, Result>(
  Result.parse
);

export const getResourceKey$ExplorePolicyList = generateGetResourceKey<Params>([
  "fea37b5b-a916-4976-8892-63fc9828f82b",
]);

export const getInfiniteResourceKey$ExplorePolicyList =
  generateGetInfiniteResourceKey<Params>([
    "15800233-3095-4f6d-b59a-fb7c0477fe42",
  ]);
